import { render, staticRenderFns } from "./auth-v2.vue?vue&type=template&id=119201ef&scoped=true&"
import script from "./auth-v2.vue?vue&type=script&lang=js&"
export * from "./auth-v2.vue?vue&type=script&lang=js&"
import style0 from "./auth-v2.vue?vue&type=style&index=0&id=119201ef&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119201ef",
  null
  
)

export default component.exports